/*
 * @Descripttion: 
 * @version: 
 * @Author: Tperam
 * @Date: 2021-04-12 09:52:30
 * @LastEditors: Tperam
 * @LastEditTime: 2021-04-23 15:51:48
 */
import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Login from './pages/Login'
import Signup from './pages/Signup'
import MultipleUser from './pages/MultipleUser'
import ForgetPwd from './pages/ForgetPwd'
import ChangePassword from './pages/ChangePassword'
import CasdoorRedirect, { CasdoorCallback, CasdoorPasswordRedirect, getAccountSignupTarget, getLegacyLoginTarget, isCasdoorAccountEnabled } from './auth/casdoor'

class ExternalRedirect extends React.Component {
  componentDidMount () {
    window.location.replace(this.props.to)
  }

  render () {
    return null
  }
}

const LegacyLogin = props => {
  const target = getLegacyLoginTarget(window.location.hostname, props.location.search)
  return target ? <ExternalRedirect to={target} /> : <Login {...props} />
}

const AccountLogin = props => isCasdoorAccountEnabled() ? <CasdoorRedirect {...props} mode="login" /> : <LegacyLogin {...props} />
const AccountSignup = props => {
  const target = getAccountSignupTarget(window.location.hostname, props.location.search)
  if (target) return <ExternalRedirect to={target} />
  return isCasdoorAccountEnabled() ? <CasdoorRedirect {...props} mode="signup" /> : <Signup {...props} />
}
const AccountForget = props => isCasdoorAccountEnabled() ? <CasdoorPasswordRedirect {...props} mode="forget" /> : <ForgetPwd {...props} />
const AccountChangePassword = props => isCasdoorAccountEnabled() ? <CasdoorPasswordRedirect {...props} mode="change" /> : <ChangePassword {...props} />
const AccountCallback = props => isCasdoorAccountEnabled() ? <CasdoorCallback {...props} /> : <Login {...props} />

const Routes = () => (
  <BrowserRouter>
    <Switch>
      {/*<Route path="/bind" component={Login}></Route>*/}
      {/*<Route path="/realname" component={Realname}></Route>*/}
      <Route path="/callback" component={AccountCallback}></Route>
      <Route path="/legacy" component={LegacyLogin}></Route>
      <Route path="/signup" component={AccountSignup}></Route>
      <Route path="/login" component={AccountLogin}></Route>
      <Route path="/forget" component={AccountForget}></Route>
      <Route path="/update/password" component={AccountChangePassword}></Route>
      <Route path="/multiple/user" component={MultipleUser} exact></Route>
      <Route path="/" component={AccountLogin} exact></Route>
      <Route path="*" component={Login}></Route>
    </Switch>
  </BrowserRouter>
)

export default Routes
